import axios from "axios";
import { API_PATHS } from "../../paths";
import NewsletterItem from "../../Model/NewsLettersModel";
import { flashMessage } from "../../../utils/flashMessageService";

/**
 * GET /api/newsletters
 */
export async function fetchNewsletters(payload = {}) {
	try {
		const res = await axios.get(API_PATHS.newsletters, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			params: payload,
		});
		const items = res.data || [];
		return items.map((i) => NewsletterItem.fromJSON(i));
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error("fetchNewsletters failed with status 400:", error.response.data);
			flashMessage(`fetchNewsletters failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error("Error fetching newsletters:", error);
			flashMessage("fetchNewsletters failed. Please try again.", { type: "error" });
		}
		console.error("fetchNewsletters error:", error);
		throw error;
	}
}

/**
 * POST /api/newsletters
 */
export async function createNewsletter(payload = {}) {
	try {
		const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
		const body = isFormData ? payload : (() => {
			const fd = new FormData();
			Object.entries(payload).forEach(([k, v]) => {
				if (v !== undefined && v !== null) fd.append(k, v);
			});
			return fd;
		})();

		const res = await axios.post(API_PATHS.newsletters, body, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("authToken")}`,
				"Content-Type": "multipart/form-data",
			},
		});
		flashMessage("Newsletter created successfully.", { type: "success" });
		return NewsletterItem.fromJSON(res.data);
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error("createNewsletter failed with status 400:", error.response.data);
			flashMessage(`createNewsletter failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error("Error creating newsletter:", error);
			flashMessage("createNewsletter failed. Please try again.", { type: "error" });
		}
		console.error("createNewsletter error:", error);
		throw error;
	}
}

/**
 * GET /api/newsletters/:id
 */
export async function fetchNewsletterById(id) {
	try {
		const res = await axios.get(API_PATHS.newslettersById(id), {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		});
		return NewsletterItem.fromJSON(res.data);
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error(`fetchNewsletterById(${id}) failed with status 400:`, error.response.data);
			flashMessage(`fetchNewsletterById failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error(`Error fetching newsletter by ID (${id}):`, error);
			flashMessage("fetchNewsletterById failed. Please try again.", { type: "error" });
		}
		console.error(`fetchNewsletterById(${id}) error:`, error);
		throw error;
	}
}

/**
 * PUT /api/newsletters/:id
 */
export async function updateNewsletter(id, payload = {}) {
	try {
		const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
		const body = isFormData ? payload : (() => {
			const fd = new FormData();
			Object.entries(payload).forEach(([k, v]) => {
				if (v !== undefined && v !== null) fd.append(k, v);
			});
			return fd;
		})();

		const res = await axios.put(API_PATHS.newslettersById(id), body, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("authToken")}`,
				"Content-Type": "multipart/form-data",
			},
		});
		flashMessage("Newsletter updated successfully.", { type: "success" });
		return NewsletterItem.fromJSON(res.data);
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error("updateNewsletter failed with status 400:", error.response.data);
			flashMessage(`updateNewsletter failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error("Error updating newsletter:", error);
			flashMessage("updateNewsletter failed. Please try again.", { type: "error" });
		}
		console.error(`updateNewsletter(${id}) error:`, error);
		throw error;
	}
}

/**
 * DELETE /api/newsletters/:id
 */
export async function deleteNewsletter(id) {
	try {
		const res = await axios.delete(API_PATHS.newslettersById(id), {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		});
		flashMessage("Newsletter deleted successfully.", { type: "success" });
		return res.data;
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error(`deleteNewsletter(${id}) failed with status 400:`, error.response.data);
			flashMessage(`deleteNewsletter failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error(`Error deleting newsletter (${id}):`, error);
			flashMessage("deleteNewsletter failed. Please try again.", { type: "error" });
		}
		console.error(`deleteNewsletter(${id}) error:`, error);
		throw error;
	}
}

